import { createSlice } from "@reduxjs/toolkit";

interface NEWSLETTERPOPUP  {
    visible: boolean;
    email?: string;
}
const initialState: NEWSLETTERPOPUP = {
    visible: false,
    email: "",
};

export const newsletterPopUp = createSlice({
    name: "newsletterPopUp",
    initialState,
    reducers: {
        showNewsletterPopUp: (state,payload) => {
            state.visible = true;
            state.email = payload.payload || "";
        }, 
        closeNewsletterPopUp: (state) => {
            state.visible = false;
            state.email = "";
        }
    },
});

export const { showNewsletterPopUp, closeNewsletterPopUp } = newsletterPopUp.actions;

export default newsletterPopUp.reducer;
